import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { ApiClientService } from './api-client.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: ApiClientService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add auth header with token if available
    const authReq = this.addTokenToRequest(request);

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized errors (token expired)
        if (error.status === 401 || error.status === 403) {
          return this.handle401Error(authReq, next);
        }
        
        // For other errors, just throw them
        return throwError(() => error);
      })
    );
  }

  private addTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
    // Get the token from your auth service or localStorage
    const token = this.getToken();

    // Skip for specific routes that don't need tokens
    if (this.isPublicRoute(request)) {
      return request;
    }

    // If token exists, add it to the request
    if (token) {
      return request.clone({
        setHeaders: {
          Token: token,
          'Content-Type': 'application/json'
        }
      });
    }

    return request;
  }

  private getToken(): string | null {
    return localStorage.getItem('authToken') || 
           sessionStorage.getItem('authToken') ||
           null;
  }

  private isPublicRoute(request: HttpRequest<any>): boolean {
    // Define routes that don't require authentication
    const publicRoutes = [
      '/api/Logins/login',
      '/assets/'
    ];

    return publicRoutes.some(route => request.url.includes(route));
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('authToken');
    localStorage.removeItem('Agroinformer-Current-User');
    sessionStorage.removeItem('Agroinformer-Current-User');
    // Redirect to login or handle token refresh logic here
    window.location.href = '/login';
    return throwError(() => new Error('Unauthorized'));
  }
}